import axios from "axios";
import config from "../config";
import jwt_decode from "jwt-decode";
import moment from "moment";

export const Method = {
    POST: "POST",
    GET: "GET",
    PUT: "PUT",
    DELETE: "DELETE"
};

export const upload = (file, success, fail) => {
    const proc = async () => {
        try {
            let headers = {};
            // headers["Content-Type"] = "application/x-www-form-urlencoded";
            headers["Content-Type"] = "multipart/form-data";

            let access_token = localStorage.getItem("access_token");
            if (access_token !== undefined && access_token !== "") {
                headers["Authorization"] = "Bearer " + access_token;
            }

            let contents = {
                method: Method.POST,
                url: process.env.REACT_APP_API_URL + "/a/upload/file/local",
                headers: headers
            };

            const formData = new FormData();
            formData.append("file", file);
            // formData.append("useOriginalName", false);

            contents["data"] = formData;
            const response = await axios(contents);

            CommonResult(response.data);
            if (success !== undefined) {
                success(response.data);
            }
        } catch (e) {
            console.log("e : " + e);
            if (fail !== undefined) {
                fail(e);
            } else {
                NetworkFail(e);
            }
        }
    };

    proc();
};

/**
 * 공통 통신 처리 부분
 */
export const send = (method, url, params, success, fail, headers) => {
    const proc = async () => {
        try {
            if (headers === undefined) {
                headers = {};
                headers["Content-Type"] = "application/json";

                let access_token = localStorage.getItem("access_token");
                if (access_token !== undefined && access_token !== "" && !url.includes("/auth/token")) {
                    let token_type = localStorage.getItem("token_type");
                    headers["Authorization"] = token_type + " " + access_token;
                }
                console.log("access_token", access_token);
            }

            // headers["Access-Control-Allow-Origin"] = "*";

            console.log("params1", params);
            console.log("params2", JSON.stringify(params));
            console.log("url", url);

            let contents = {
                method: method,
                url: process.env.REACT_APP_API_URL + url,
                headers: headers
            };

            if (method === "GET") {
                contents["params"] = params;
            } else {
                contents["data"] = params;
            }

            const response = await axios(contents);

            CommonResult(response.data);
            if (success !== undefined) {
                success(response.data);
            }
        } catch (e) {
            console.log("e : " + e);

            if (fail !== undefined) {
                fail(e);
            } else {
                NetworkFail(e);
            }
        }
    };

    let access_token = localStorage.getItem("access_token");
    if (access_token !== null && access_token !== "" && !url.includes("/auth/token")) {
        var decoded = jwt_decode(access_token);
        if (moment().isAfter(moment.unix(decoded.exp).subtract(30, "minutes"))) {
            AuthToken(
                this,
                "refresh_token",
                res => {
                    proc();
                },
                res => {
                    localStorage.setItem("access_token", "");
                    localStorage.setItem("refresh_token", "");
                    window.location.href = "/";
                }
            );
        } else {
            proc();
        }
    } else {
        proc();
    }
};

const CommonResult = response => {
    console.log(JSON.stringify(response));

    if (response["access_token"] !== undefined) localStorage.setItem("access_token", response["access_token"]);
    if (response["refresh_token"] !== undefined) localStorage.setItem("refresh_token", response["refresh_token"]);
    if (response["token_type"] !== undefined) localStorage.setItem("token_type", response["token_type"]);
    if (response["expires_in"] !== undefined) localStorage.setItem("expires_in", response["expires_in"]);
};

const NetworkFail = response => {
    console.log("response", JSON.stringify(response));
    if (response.message !== undefined && response.message.indexOf("code 401") !== -1) {
        // this.props.history.push("/auth/signout");

        // window.location = window.location.origin + "/auth/signout";
        // alert("!!" + JSON.stringify(response.response.data.message));
        localStorage.setItem("role", "");
        window.location = window.location.origin;
    } else {
        alert(response.response.data.message);
    }
    // alert("네트워크 연결 실패 : " + JSON.stringify(response));
};

/**
 * 토큰 받기
 */
export const AuthToken = (grant_type, success, fail) => {
    var params = {
        client_id: "21232f297a57a5a743894a0e4a801fc3",
        secret_key: "3RUDRSCEijVC7lMvsjluobGfaWt27jTbOs2nOSp9",
        grant_type: grant_type,
        refresh_token: grant_type === "refresh_token" ? localStorage.getItem("refresh_token") : ""
    };
    if (grant_type === "client_credentials") {
        localStorage.setItem("access_token", "");
    }

    send(Method.POST, `/auth/token`, params, success, fail);
};

/**
 * 로그인 처리
 */
export const AuthLogin = (email, password, success, fail) => {
    var params = {
        email: email,
        password: password
    };

    send(Method.POST, "/a/auth/login", params, success, fail);
};

/**
 * 로그인 아웃
 */
export const AdminSignout = (success, fail) => {
    var params = new FormData();

    send(Method.POST, "/a/auth/logout", params, success, fail);
};

/**
 * 종목 정보
 */
export const GetStock = (id, success, fail) => {
    var params = new FormData();

    send(Method.GET, `/a/stock/ticker/${id}`, params, success, fail);
};
